/** TRACKING  */
export const TRACKING = {};
/** RACKING_LOGGING_STATUS */
export const TRACKING_LOGGING_STATUS = {
    LOGGED_IN: 'logged in',
    NOT_LOGGED_IN: 'not logged in',
};
/** Error_Track_TYPES */
export const Error_Track_TYPES = {
    ValidationError: 'validation',
    FunctionalError: 'functional',
    TechincalError: 'technical',
    AuthenticationError: 'authentication',
    AuthorizationError: 'authorization',
    notification: '',
};
/** RROR_TRACKING_MAP */
export const ERROR_TRACKING_MAP = {
    400: Error_Track_TYPES.ValidationError,
    401: Error_Track_TYPES.ValidationError,
    402: Error_Track_TYPES.AuthenticationError,
    403: Error_Track_TYPES.AuthenticationError,
    404: Error_Track_TYPES.TechincalError,
    500: Error_Track_TYPES.TechincalError,
    503: Error_Track_TYPES.TechincalError,

};
/** ADDITIONAL_TRACKING_ACTIONS  */
export const ADDITIONAL_TRACKING_ACTIONS = {

    HOT_LINE: {
        TYPE: 'hotline cta',
    },
    WHATSAPP: {
        TYPE: 'whatsapp cta',
    },
    SMS: {
        TYPE: 'sms cta',
    },
    DOWNLOAD_FILE: {
        TYPE: 'download file',
    },
    INFORMATION: {
        TYPE: 'information',
    },
    CONTACT: {
        TYPE: 'contact',
    },
};
/** BTN_TYPES */
export const BTN_TYPES = {
    SALES: 'sales',
    WINBACK: 'winback',
};
/** SALES_AGENT_TRACKING_VALUES */
export const SALES_AGENT_TRACKING_VALUES = {

    SIM_HARDWRE: {
        BUNDLE_CANCEL_TARIFF: 'bundle cancel tariff',
        STEP_NAME: 'winback',
    },
    SIM_ONLY: {
        SIM_ONLY_NOT_HAPPY: 'sim only not happy',
        STEP_NAME: 'summary',
    },
    ESIM_HARDWARE: {
        BUNDLE_CANCEL_TARIFF: 'bundle cancel tariff esim',
        STEP_NAME: 'winback',
    },
};
/** SALES_AGENT_TRACKING_VALUES */
export const REVOCATION_ESIM_ONLY = {
    ESIM_ONLY_NOT_HAPPY: 'esim only not happy',
    STEP_NAME: 'summary',
};
/** LOGIN_SUCCESS */
export const LOGIN_SUCCESS = {
    STORE_AFTER_SALES_LOGIN: 'after sales login',
    CUSTOMER_TYPE_MAPPING: {
        TIGER: 'credit sim only',
        LION: 'credit with hardware',
        SNOWLION: '2nd credit with hardware',
        SNOWTIGER: '2nd credit with sim only',
        LEOPARD: 'credit with hardware vvl',
        POLARBEAR: 'credit with hardware GIGCUBE',
        SNOWLEOPARD: '2nd credit with hardware vvl',
        RABBIT: 'accessory',
        PYTHON: 'dsl with hardware purchase',
        COBRA: 'dsl with hardware rental',
        MONKEY: 'otelo sim only',
        PANDA: 'otelo with hardware',
        COLIBRI: 'second delivery',
        ELEPHANT: 'enterprise',
    },
    LOGIN_PERIOD: {
        WITHIN_14_DAYS: 'yes',
        NOT_WITHIN_14_DAYS: 'no',
        HAPPINESS: 'happiness',
    },
    LAYOVER: {
        LAYOVER_KEY: 'layover',
        ACTION: 'show',
        MODAL_TYPE: {
            orderModal: 'order number',
            deliveryModal: 'delivery number',

        },
    },
    DELIVERY_STATUS: {
        REVOKE: 'revoke',
        FORWARD_TO_AGENT: 'forwardToAgent',
    },
};
/** REVOCATION_CONTRACT_HARDWARE */
export const REVOCATION_CONTRACT_HARDWARE = {
    CONFIRMATION: {
        RETENTION: {
            NEW_CONTRACT: 'newcontract',
            PROLONGATION: 'prolongation',
        },
    },
};
/** SIM_HARDWARE_REVOCATION_CONFIRMATION */
export const SIM_HARDWARE_REVOCATION_CONFIRMATION = {

    MODULE_NAME: 'bundle other device',
    STEP_NUMBER: 4,
};
/** ESIM_HARDWARE_REVOCATION_CONFIRMATION */
export const ESIM_HARDWARE_REVOCATION_CONFIRMATION = {

    MODULE_NAME: 'bundle other device esim',
    STEP_NUMBER: 4,
};
/** ESIM_HARDWARE_DEFECT_CONFIRMATION */
export const ESIM_HARDWARE_DEFECT_CONFIRMATION = {

    MODULE_NAME: 'bundle defect esim',
    STEP_NUMBER: 4,
};
/** WINBACK_CONFIRMATION */
export const WINBACK_CONFIRMATION = {

    SIM_ONLY_STEP_NUMBER: 2,
    SIM_HARDWRE_STEP_NUMBER: 3,
};
/** LOGIN_METHOD */
export const LOGIN_METHOD = {
    MSISDN: 'MSISDN',
    DELIVERY_NUMBER: 'delivery number',
};
/** NO_DEVICES_ARE_AVAILABLE */
export const NO_DEVICES_ARE_AVAILABLE: string = 'no device available';
/** REVOCATION_NOT_APPLICABLE */
export const REVOCATION_NOT_APPLICABLE: string = 'not applicable';
/** export const REVOCATION_CLEANUP_NOENTITLED */
export const REVOCATION_CLEANUP_NOENTITLED: string = 'u';
/** ORIGINAL_SALES_STATUS_CLEANUP_NOENTITLED */
export const ORIGINAL_SALES_STATUS_CLEANUP_NOENTITLED: string = 'no order status';
/** STATUS */
export const STATUS = {
    START: ['start'],
};
/** ORDER_SUMMARY_CONFIRMATION_NEW_FLOW_TRACKING */
export const ORDER_SUMMARY_CONFIRMATION_NEW_FLOW_TRACKING = (siteStructure = [], name, formStep, formStepName, formStatus, context?, outcome?, isLoggedIn = true) => {
    return {
        module: name,
        step: formStep,
        stepName: formStepName,
        status: formStatus,
        hasOApplication: false,
        isCustomSiteStructure: true,
        type: 'after sales portal',
        siteArea: 'after sales',
        platformType: 'responsive',
        context: context,
        outcome: outcome,
        siteStructure: [
            'privatkunden',
            'after sales portal',
        ].concat(siteStructure),
        loginStatus: !isLoggedIn ? TRACKING_LOGGING_STATUS.NOT_LOGGED_IN : TRACKING_LOGGING_STATUS.LOGGED_IN,

    };
};
/**
 * RETURN_OPTIONS
 */
export const RETURN_OPTIONS = {
    REPEATED_DOWNLOAD: 'repeated download',
    FIRST_DOWNLOAD: 'first download',
    qrCode: {
        NAME: 'download qr code',
        STEP_NAME: 'request qr code',
    },
    freightLabel: {
        NAME: 'download return label',
        STEP_NAME: 'request return label',
    },
};
/**
 * QR_CODE_CONFIRMATION
 */
export const QR_CODE_CONFIRMATION = {
    NAME: 'download qr code',
    PER_MAIL: {
        SHOW_EMAIL_INPUT: {
            STEP_NAME: 'per email',
        },
        STEP_NAME: 'confirmation qr mailed',
        STEP_NUMBER: 3,
        REQUEST_CODE_AGAIN: {
            OUTCOME: 'send qr mail again',
        },
        OUTCOME_NEW_EMAIL: 'new email used',
    },
    DIRECT_DOWNLOAD: {
        STEP_NAME: 'confirmation qr direct download',
        STEP_NUMBER: 2,
        REQUEST_CODE_AGAIN: {
            OUTCOME: 'download qr-code again',
        },
    },
    NEW_EXTENSION: {
        PER_MAIL: {
            NEW_OUTCOME: 'new mail used',
            REPEATED_OUTCOME: 'send qr mail again',
        },
        DIRECT_DOWNLOAD: {
            NEW_OUTCOME: 'qr code downloaded',
        },
    },
};

/**
 * FREIGHT_LABEL_CONFIRMATION
 */
export const FREIGHT_LABEL_CONFIRMATION = {
    NAME: 'download return label',
    PER_MAIL: {
        SHOW_EMAIL_INPUT: {
            STEP_NAME: 'per email',
        },
        STEP_NAME: 'confirmation return label mailed',
        STEP_NUMBER: 3,
        REQUEST_CODE_AGAIN: {
            OUTCOME: 'send return label mail again',
        },
        OUTCOME_NEW_EMAIL: 'new email used',
    },
    DIRECT_DOWNLOAD: {
        STEP_NAME: 'confirmation return label direct download',
        STEP_NUMBER: 2,
        REQUEST_CODE_AGAIN: {
            OUTCOME: 'download return label again',
        },
    },
    NEW_EXTENSION: {
        PER_MAIL: {
            NEW_OUTCOME: 'new mail used',
            REPEATED_OUTCOME: 'send return label mail again',
        },
        DIRECT_DOWNLOAD: {
            NEW_OUTCOME: 'return label downloaded',
        },
    },
};


/** TRACKING_STATUS */
export const TRACKING_STATUS = {
    START: ['start'],
    END_SUCCESS:  ['end', 'success'],
    END_FAILURE: ['end', 'failure'],
    EMPTY: [],
};
/** TRACKING_PAGE_TYPES */
export const TRACKING_PAGE_TYPES = {
    PAGE_TYPE_SELF: 'self service',
};
/** TRACKING_PLATFORM_TYPES */
export const TRACKING_PLATFORM_TYPES = {
    RESPONSIVE: 'responsive',
};
/** TRACKING_FORM_TYPES */
export const TRACKING_FORM_TYPES = {
    AFTER_SALES_PORTAL: 'after sales portal',
};

/** LANDING_PAGE_TRACKING */
export const LANDING_PAGE_TRACKING = {
    SITE_AREA: 'after sales',
    PRODUCT_SELECTED: {
        SITE_STRUCTURE: ['privatkunden', 'after sales portal', 'return portal prestart', 'product selected'],
        NAME: 'return portal prestart',
        STEP: 2,
        STEP_NAME: 'product selected',
    },
    SERVICE_SELECTED: {
        SITE_STRUCTURE: ['privatkunden', 'after sales portal', 'return portal prestart', 'service selected'],
        NAME: 'return portal prestart',
        STEP: 3,
        STEP_NAME: 'service selected',
    },
    OUTCOMES: {
        REVOKATION_KD: 'kd, revocation,',
        REVOKATION_UM: 'um, revocation',
        LABELONLY_KD: 'kd, return hardware',
        LABELONLY_UM: 'um, return hardware',
        TERMINATION_KD: 'kd, termination',
        TERMINATION_UM: 'um, termination',
        MOBILE: 'mobilfunk and gigacube',
        ACCESSORIES: 'gerat ohne vertrag',
        DSL: 'dsl internet',
        TERMINATION_DSL:'dsl, termination',
        REVOKATION_DSL:'dsl, revocation',
        LABELONLY_DSL:'dsl, return hardware',
    },
};
/** FLOW_MANAGMENT_OUTCOME_TRACKING */
export const FLOW_MANAGMENT_OUTCOME_TRACKING = {
    TECHNICAL_PROBLEM: 'technical problems',
    NOT_HAPPY_TARIFF: 'not happy with the tariff',
    OTHER_QUESTIONS: 'further questions',
    FATILITY: 'fatality',
    MARKETING_ONE: 'marketing one',
    MARKETING_TWO: 'marketing two',
    MARKETING_THREE: 'marketing three',

};
/** RETURN_DEVICES_MODULE */
export const RETURN_DEVICES_MODULE = 'return hardware';
/** MAPPED_PERSONAS */
export const MAPPED_PERSONAS = {
    Fox: 'termination kd',
    Deer: 'termination um',
    Camel: 'revocation kd',
    Giraffe: 'revocation um',
    Moose: 'termination dsl',
    Buffalo: 'revocation dsl',
    Cobra: 'revocation dsl',
    Python: 'revocation dsl',
    Cheetah: 'return hardware' ,
    Dolphine: 'return hardware',
};
/** LANDING_PAGE_TRACKING */
export const KABLE_UM_CONFIRMATION_PAGE_TRACKING = {
    SITE_AREA: 'after sales',
    LABEL_ONLY: {
        SITE_STRUCTURE: ['privatkunden', 'after sales portal', 'return hardware', 'overview - download'],
        NAME: 'return hardware',
        STEP: 2,
        STEP_NAME: 'overview - download',
        STATUS : [
            'end',
            'success',
          ],
    },
    OTHER_TYPES: {
        SITE_STRUCTURE: ['privatkunden', 'after sales portal', '{{persona}}', 'overview - download'],
    },
};
export const DSL_CONFIRMATION_PAGE_TRACKING = {
    SITE_AREA: 'after sales',
    LABEL_ONLY: {
        SITE_STRUCTURE: ['privatkunden', 'after sales portal', 'return hardware', 'overview - download'],
        NAME: 'return hardware',
        STEP: 2,
        STEP_NAME: 'overview - download',
        STATUS : [
            'end',
            'success',
          ],
    },
    OTHER_TYPES: {
        SITE_STRUCTURE: ['privatkunden', 'after sales portal', '{{persona}}', 'overview - download'],
    },
};
 /** TERMINATION_REASONS */
 export const TERMINATION_REASONS = {
    THERE_IS_DEATH: {
        ID: 'there-a-death',
        CONTEXT: 'fatality',
    },
};
/** REASON_CHOOSER_OVERLAY_TRACKING */
export const REASON_CHOOSER_OVERLAY_TRACKING = {
    DATA: {
        information_action: 'reveal',
        information_name: 'please choose another reason',
        information_ui_type: 'overlay',
        information_trigger: 'button',
    },
};
/** WHATSAPP_TRACKING */
export const WHATSAPP_TRACKING = {
    DATA: {
        contact_action: 'engage',
        contact_tool: 'whatsapp',
        contact_trigger: 'button',
},
}
/** MAPPED_CUSTOMER_TYPE */
export const MAPPED_CUSTOMER_TYPES = {
    Fox: 'kd',
    Deer: 'um',
    Camel: 'kd',
    Giraffe: 'um',
    Moose: 'dsl',
    Buffalo: 'dsl',
    Cobra: 'dsl',
    Python: 'dsl',
    Cheetah: {
        VKD: 'kd',
        UM: 'um',
    },
    Dolphine: 'dsl',
};
